// Price splitting for client-side display (mirrors backend/src/events/refund/price.ts's
// toPriceFromGross exactly, so the Abrechnung wizard's wine list shows the same
// split the backend will compute at preview/submit time).

import { TAX_CATEGORY_PERCENT, type TaxCategoryKey } from '@/types';

export interface Money {
  centAmount: number;
  currencyCode: string;
}

export interface Price {
  netto: Money;
  brutto: Money;
}

/** Builds a full Price from a gross amount and the applicable VAT category. */
export function toPriceFromGross(
  grossCents: number,
  currencyCode: string,
  taxCategory: TaxCategoryKey
): Price {
  const percent = TAX_CATEGORY_PERCENT[taxCategory];
  const netCents = Math.round(grossCents / (1 + percent / 100));
  return {
    netto: { centAmount: netCents, currencyCode },
    brutto: { centAmount: grossCents, currencyCode },
  };
}

/** Builds a full Price from a net amount and the applicable VAT category. */
export function toPriceFromNet(
  netCents: number,
  currencyCode: string,
  taxCategory: TaxCategoryKey
): Price {
  const percent = TAX_CATEGORY_PERCENT[taxCategory];
  const grossCents = Math.round(netCents * (1 + percent / 100));
  return {
    netto: { centAmount: netCents, currencyCode },
    brutto: { centAmount: grossCents, currencyCode },
  };
}

/** The VAT amount itself — brutto minus netto. */
export function vatAmount(price: Price): Money {
  return {
    centAmount: price.brutto.centAmount - price.netto.centAmount,
    currencyCode: price.brutto.currencyCode,
  };
}
